import { render } from "./ChangeBio.vue.js?vue&type=template&id=1739dc37!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangeBio.vue?vue&type=template&id=1739dc37"
import script from "./ChangeBio.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangeBio.vue?vue&type=script&lang=js"
export * from "./ChangeBio.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangeBio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/user-settings-page/ChangeBio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1739dc37"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1739dc37', __exports__)) {
    api.reload('1739dc37', __exports__)
  }
  
  module.hot.accept("./ChangeBio.vue.js?vue&type=template&id=1739dc37!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangeBio.vue?vue&type=template&id=1739dc37", () => {
    api.rerender('1739dc37', render)
  })

}


export default __exports__